import { z } from 'zod';
import { EntityType } from '$lib/sanity/types';
import {
  SanityDocumentSchema,
  SanityFileObjectSchema,
  SanityImageObjectSchema,
  SanityReferenceSchema
} from '../sanity';
import { ImageAssetSchema, ShapeLinkGroupSchema } from '../components';
import { SEOSchema } from '../shared/SEO';

const MediaKitCollectionPageHeader = z.object({
  title: z.string()
});

const MediaKitAssetSectionSchema = z.object({
  title: z.string(),
  lastUpdated: z.string(),
  caption: z.string(),
  file: SanityFileObjectSchema,
  images: z.array(ImageAssetSchema),
  imageRefs: z.array(SanityImageObjectSchema)
});

const MediaKitMoreMediaSectionSchema = z.object({
  title: z.string(),
  caption: z.string(),
  links: z.lazy(() => ShapeLinkGroupSchema.or(SanityReferenceSchema))
});

export const MediaKitLandingPageSchema = SanityDocumentSchema.extend({
  _type: z.literal(EntityType.MediaKitLandingPage),
  header: MediaKitCollectionPageHeader,
  seoAttributes: SEOSchema.nullish(),
  assetSections: z.array(MediaKitAssetSectionSchema),
  moreMedia: MediaKitMoreMediaSectionSchema
});

export type MediaKitLandingPage = z.infer<typeof MediaKitLandingPageSchema>;
export type MediaKitAssetSection = z.infer<typeof MediaKitAssetSectionSchema>;
export type MediaKitMoreMediaSection = z.infer<typeof MediaKitMoreMediaSectionSchema>;
